<template>
  <div
    :class="[
      'hab-tabs',
      {
        [`${className}`]: className,
      },
    ]"
  >
    <div class="hab-tabs-heade">
      <span
        v-for="(tab, index) in dataSource"
        :key="index"
        :class="['item', { active: active === get(tab, 'value', '') }]"
        v-on:click="() => onTabs(tab)"
        >{{ get(tab, 'name', '') }}</span
      >
    </div>
    <div class="hab-tabs-contents"><slot></slot></div>
  </div>
</template>
<script>
import { get } from "lodash"
export default {
  props: {
    className: {
      type: String,
      default: "",
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    active: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["onTabs"],
  methods: {
    get,
    onTabs(tab) {
      return this.$emit("onTabs", tab);
    }
  }
};
</script>
